document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_BackgroundVideo', () => ({
    playing: false,
    // Keep the video (and its poster image) visible even when autoplay is
    // blocked (e.g. iOS Low Power Mode). Previously the video was opacity-0
    // until it was playing, so blocked autoplay left an empty green section.
    player: {
      'x-ref': 'video',
    },
    init() {
      this.$nextTick(() => {
        const video = this.$refs.video;
        if (!video) return;

        // Make sure mobile browsers treat this as a silent inline video
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');

        video.addEventListener('play', () => {
          this.playing = true;
        });

        video.addEventListener('pause', () => {
          this.playing = false;
        });

        // Safari won't autoplay inserted videos
        if (video.autoplay) {
          this.$nextTick(() => this.tryPlay());
        }
      });
    },
    tryPlay() {
      const video = this.$refs.video;
      if (!video) return;
      const attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') {
        attempt.catch(() => {
          // Autoplay blocked: poster stays visible, start on first tap/click
          const events = ['touchend', 'click'];
          const resume = () => {
            video.play().catch(() => {});
            events.forEach((evt) => window.removeEventListener(evt, resume));
          };
          events.forEach((evt) => window.addEventListener(evt, resume, { passive: true }));
        });
      }
    },
    play() {
      this.tryPlay();
    },
    pause() {
      this.$refs.video.pause();
    },
  }));
});
